<template>
<div class="content">
  <!-- <div v-if="data.length" class="block departStructure">
    <el-tree
      ref="tree"
      :data="data"
      node-key="id"
      :highlight-current="false"
      :expand-on-click-node="false"
      :indent="30"
      :accordion="true"
      :props="{
        label: 'name',
        children: 'subList'
      }"
      >
      <div class="custom-tree-node" slot-scope="{ node, data }">
        <div style="display: flex">
          <span class="level-path">{{data.levelPath}}</span>
          <span style="margin-left: 5px;display: inline-block;">{{data.name}}</span>
        </div>
      </div>
    </el-tree>
  </div> -->
  <Dialog
    v-model="dialogtree" :width="'80%'"
    :title="'选择课程目录'" :footer="true" :showClose="false"
    @confirm="handleConfirm" @close="handleClose"
  >
    <template slot="dialog-content">
      <div class="block" style="height: calc(100% - 26px);">
        <el-tree
          ref="tree"
          :data="allTreeData"
          show-checkbox
          node-key="id"
          :default-checked-keys="checkedKeys"
          :highlight-current="false"
          :expand-on-click-node="false"
          :check-on-click-node="true"
          :indent="30"
          :accordion="true"
          :props="{
            label: 'name',
            children: 'subList'
          }"
          >
          <div class="custom-tree-node" slot-scope="{ node, data }">
            <div style="display: flex">
              <span class="level-path">{{data.levelPath}}</span>
              <span style="margin-left: 5px;display: inline-block;">{{data.name}}</span>
            </div>
          </div>
        </el-tree>
      </div>
      <el-checkbox style="margin-top:6px"
        v-model="allchecked"
        :true-label="1"
        :false-label="0"
        @change="handleChange"
      >全选</el-checkbox>
    </template>
  </Dialog>
</div>
</template>

<script>
// import { courseServer } from '@/api/api'
import { courseServer } from '@/api/api'
export default {
  props: ['data', 'allTreeData', 'dialogtree', 'professionId'],
  data () {
    return {
      allchecked: false,
      checkedKeys: []
    }
  },
  methods: {
    handleConfirm () {
      // 所有id
      // let directoryIds = this.$refs.tree.getCheckedKeys();
      // let directoryIds = [this.$refs.tree.getCheckedKeys(), 134];
      const directoryIds = this.findParentIds(this.allTreeData, this.$refs.tree.getCheckedKeys());
      // console.log(directoryIds, 'directoryIds')
      // return
      courseServer.configDirectory({
        professionId: this.professionId,
        directoryIds: directoryIds.join()
      }).then(res => {
        const {code, data, message} = res
        if (code === '0') {
          this.$emit('update:dialogtree', false)
          this.$emit('update')
          this.$message.success(message)
        } else {
          this.$message.error(message)
        }
      }).catch((error) => {
        this.$message.error(error)
      })
    },
    findParentIds(data, targetIds) {
      if(data.length <= 0) return;
      const idMap = new Map();
      const result = new Set();
      const buildMap = (nodes) => {
        nodes.forEach(node => {
          idMap.set(node.id, node);
          if (node.subList && node.subList.length > 0) {
            buildMap(node.subList);
          }
        });
      }
      buildMap(data);
      const findParents = (id) => {
        const node = idMap.get(id);
        if (!node) return;
        result.add(id);
        if (node.parentId !== null) {
          findParents(node.parentId);
        }
      }
      targetIds.forEach(id => {
        if (idMap.has(id)) {
          findParents(id);
        }
      });
      return Array.from(result);
    },
    returnResult (arr) {
      const result = [];
      function flatten(items) {
        for (const item of items) {
          const { subList, ...rest } = item;
          const newItem = { ...rest };
          result.push(newItem);
          if (subList && subList.length) {
            flatten(subList, newItem);
          }
        }
      }
      flatten(arr);
      return result;
    },
    setChecked () {
      if (JSON.stringify(this.allTreeData) === JSON.stringify(this.data)) this.allchecked = true
      /**
       * 问题：由于设置详情返回的选中值中涉及到有父选项框，则父选框选中时，也会导致子选项都会被选中
       * 解决：如下
       * 注意：一定要设置setTimeout，延迟处理，否则选框没法去掉不选中
       */
      // 收集需要回显节点的 id
      const idsToCheck = this.returnResult(this.data).map(item => item.id)
      this.$refs.tree.setCheckedKeys(idsToCheck)
      setTimeout(() => {
        // 获取树中所有选中的值
        let defaultCheckAll = this.$refs.tree.getCheckedKeys()
        // 通过对比树所有选中的值（defaultCheckAll）和详情返回选中的值（res.data.menuIdDtos）去取两个数组的差集
        let deleteArr = defaultCheckAll.filter(item => !idsToCheck.some(item_1 => item_1 === item))
        // 遍历去掉不需要选中的值
        deleteArr.map(item => {
          this.$refs.tree.setChecked(item, false)
        })
      }, 200)
    },
    handleClose () {
      this.allchecked = false
      this.$emit('update:dialogtree', false)
    },
    handleChange (v) {
      if (v === 1) {
        this.$refs.tree.setCheckedNodes(this.allTreeData)
      } else {
        this.$refs.tree.setCheckedKeys([])
      }
    },
  }
}
</script>

<style lang='scss' scoped>
.content {
  height: calc(100vh - 172px);
}
.block {
  height: 100%;
  // align-self: baseline;
  width: 100%;
  overflow: auto;
  .custom-tree-node {
    width: 100%;
    display: flex;
    align-items: baseline;
    text-align: left;
  }
  .level-path {
    display: inline-block;
    align-self: center;
    // width: 20px;
  }
}

/deep/.departStructure .el-tree {
  max-height: calc(100vh - 176px);
  overflow: auto;
}
</style>


// WEBPACK FOOTER //
// src/views/system/tree.vue